// extracted by mini-css-extract-plugin
module.exports = {"toggleSidePanelButton":"NavBar_toggleSidePanelButton__31PZu","navBar":"NavBar_navBar__1T1n3","navbarBrand":"NavBar_navbarBrand__mIyu8"};